import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBCardImage, MDBTypography, MDBBtn, MDBBadge, MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalBody, MDBModalTitle, MDBIcon } from 'mdb-react-ui-kit';
import { useCart } from '../components/CartContext.js';
import { Link, useNavigate } from 'react-router-dom';
import { getMemberTransactions, membersessions, getPlans } from '../../services/memberApiServices';
// import CreateMember from "../components/createMember";
import CreateMember from "../../components/createMember";
import defaultImg from "../../components/images/defaultPerson.png";
import moment from "moment";
import coach from "../../memberportal/assets/images/coaching.png";
import { formatDate, formatDateTimeWithTZ } from '../../utils/DateFormat';
import ftinessloader from '../../memberportal/assets/images/loader.gif';
import { BasePlanName } from '../../utils/BasePlanName';

const MemberProfile = () => {
    const { getMemberId, handleReload, getGymId } = useCart();
    const navigate = useNavigate();
    const [memberData, setMemberData] = useState({});
    const [loading, setLoading] = useState(true);
    const [editMember, setEditMember] = useState(false)
    const toggleEdit = () => { setEditMember(!editMember) }
    const [sessionData, setSessionData] = useState([])
    const [refresh, setRefresh] = useState(false)
    const [plans, setPlans] = useState("");

    useEffect(() => {
        const fetchMemberData = async () => {
            try {
                if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
                    navigate('/memberlogin', { state: { path: window.location.pathname } })
                    return
                }
                setLoading(true);
                const response = await getMemberTransactions(getMemberId());
                if (response && response !== "false") {
                    const data = await response.json();
                    if (data && data.length > 0) {
                        setMemberData(data[0]);
                    }
                }
            } catch (error) {
                console.error("Error fetching member data:", error);
            } finally {
                setLoading(false);
                setRefresh(false)
            }
        };


        async function fetchPlans() {
            try {
                const loggedUser = JSON.parse(localStorage.getItem("memberinfo"));
                const planResponse = await getPlans(loggedUser.gymid);

                if (!planResponse || planResponse === "false") {
                    //   setApiError(true);
                } else {
                    const plans = await planResponse.json();
                    if (plans) {
                        setPlans(plans);
                    }
                }
            } catch (error) {
                console.error("Error fetching plans:", error);
                // setApiError(true);
            }
        }

        fetchPlans();

        fetchMemberSession()
        fetchMemberData();






    }, [getMemberId, refresh]);



    const fetchMemberSession = async () => {
        if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
            navigate('/memberlogin', { state: { path: window.location.pathname } })
            return
        }
        const resp = await membersessions(getMemberId());

        if (!resp) {

            return;
        }
        if (resp === "false") {
            // setApiError(true)
            return;
        }
        const sessionData = await resp.json();
        console.log(sessionData);
        setSessionData(sessionData)
    }



    const handleRefresh = () => {
        setRefresh(true)
        handleReload()
    }



    if (loading) {
        return (
            // <div className="dashboard-container">
            //     <Sidebar active={"4"} handleRefresh={handleRefresh} />
            //     <div className="main-content">
            //         <Header title={"Member Profile"} />
            //         <div className="dashboard-content">
            //             <div className="text-center my-5">
            //                 <div className="spinner-border text-primary" role="status">
            //                     <span className="visually-hidden">Loading...</span>
            //                 </div>
            //                 <p>Loading member profile...</p>
            //             </div>
            //         </div>
            //     </div>
            // </div>
            <div className="dashboard-loading"> <div><img src={ftinessloader} alt="" /> </div> <h4 className='mt-2'> Loading.....</h4></div>
        );
    }

    if (!memberData) {
        return (
            <div className="dashboard-container">
                <Sidebar active={"4"} handleRefresh={handleRefresh} />
                <div className="main-content">
                    <Header title={"Member Profile"} />
                    <div className="dashboard-content">
                        <div className="alert alert-danger">Failed to load member data</div>
                    </div>
                </div>
            </div>
        );
    }

    // Format member data
    const formattedData = {
        name: `${memberData.fname} ${memberData.lname}`,
        email: memberData.email,
        phone: memberData.number,
        memberId: memberData.mid,
        image: memberData.imgurl,
        address: memberData.address ? memberData.address : '--',
        age: memberData.age,
        gender: memberData.sex,
        bloodGroup: memberData.bloodgroup,
        height: memberData.height ? `${memberData.height} cm` : "--",
        weight: memberData.weight ? `${memberData.weight} kg` : "--",
        checkInStatus: memberData.checkinflag ? "Auto check-in" : "Manual check-in",
        lastCheckIn: memberData.checkindate ? new Date(memberData.checkindate).toLocaleDateString() : "Never"
    };

    console.log("formattedData", formattedData)
    const onsubmit = () => {

    }
    const createMemberCallback = () => {
        toggleEdit()
    }
    const addandSave = null

    let membership = {};
    let PauseObj = {};
    let session = sessionData.length > 0 && sessionData.filter(item => item.transid === memberData?.trans[0]?._id)
    if (memberData && memberData?.trans?.length > 0) {
        const { plan, addons, subplan } = memberData;
        let membertrans = memberData.trans.filter((obj) => obj.isplan == "1" && (new Date() < new Date(obj.expirydate))).sort((a, b) => b.expirydate - a.expirydate);
        let membertran = memberData.trans.sort((a, b) => b.expirydate - a.expirydate);

        if (plan && plan.length > 0 && membertrans.length > 0) {
            membership = plan.find(item => item._id === membertrans[0].itemid) || {};
            session = sessionData.length > 0 && sessionData.filter(item => item.transid === membertrans[0]?._id)
        }

        if (plan && plan.length > 0 && !membership._id) {
            membership = plan.find(item => item._id === membertran[0].itemid) || {};
            session = sessionData.length > 0 && sessionData.filter(item => item.transid === membertrans[0]?._id)
        }


        if (addons && addons.length > 0 && !membership._id) {
            membership = addons.find(item => item._id === membertran[0].itemid) || {};
            if (membership._id) {
                membership.membershiptype = 'addon';
            }
        }

        if (subplan && subplan.length > 0 && !membership._id) {
            membership = subplan.find(item => item._id === membertran[0].itemid) || {};
            if (membership._id) {
                let baseName = "";
                if (membership.baseplan) {
                    baseName = BasePlanName(plans, membership.baseplan);
                }


                membership.displayName = baseName
                    ? `${baseName}-${membership.name}`
                    : membership.name;
            }
        }

    }
    const remainingSessions = session && session.length > 0 ? session[0].balsessions : null

    console.log(memberData, 'memberData');

    const calculateDuration = (start, end) => {
        const startTime = new Date(start);
        const endTime = new Date(end);
        const durationMs = endTime - startTime;

        const hours = Math.floor(durationMs / (1000 * 60 * 60));
        const minutes = Math.floor((durationMs % (1000 * 60 * 60)) / (1000 * 60));

        return `${hours}h ${minutes}m`;
    };

    return (
        <>
            <div className="dashboard-container">
                <Sidebar active={"5"} handleRefresh={handleRefresh} />
                <div className="main-content">
                    <Header title={"Member Profile"} />

                    <div className="dashboard-content">
                        <MDBRow>
                            {/* Left Column - Personal Details and Recent Activity */}
                            <MDBCol className='col-12'>
                                <MDBRow>
                                    {/* Right Column - Profile Image Card and Membership Plan */}
                                    <MDBCol sm={12} md={6} className='mb-3'>
                                        {/* Profile Image Card at the top */}
                                        <MDBCard className=" shadow h-100">
                                            <MDBCardBody className="d-block d-md-flex align-items-center">
                                                <div className='profile-member-dp position-relative'>
                                                    <MDBCardImage
                                                        src={formattedData.image ? formattedData.image : defaultImg}
                                                        alt="avatar"
                                                        className="rounded-circle"
                                                        style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                                                        onError={(e) => {
                                                            e.target.src = 'https://via.placeholder.com/150';
                                                        }}
                                                    />
                                                    <div className="edit_button">
                                                        <MDBIcon fas icon="user-edit" onClick={() =>
                                                            setEditMember(true)
                                                        } />
                                                    </div>
                                                </div>
                                                <div className=" ms-4 flex-grow-1 profile-detail">
                                                    <MDBTypography tag="h4" className='profile-name'>{formattedData.name}</MDBTypography>

                                                    <MDBRow className='mb-1'>
                                                        <MDBCol sm="4">
                                                            <MDBTypography className="mb-0 text-secondary">Member ID</MDBTypography>
                                                        </MDBCol>
                                                        <MDBCol sm="8" className="text-dark">
                                                            {formattedData.memberId}
                                                        </MDBCol>
                                                    </MDBRow>
                                                    {formattedData.phone &&
                                                        <MDBRow>
                                                            <MDBCol sm="4">
                                                                <MDBTypography className="mb-0 text-secondary">Mobile</MDBTypography>
                                                            </MDBCol>
                                                            <MDBCol sm="8" className="text-dark">
                                                                {formattedData.phone}
                                                            </MDBCol>
                                                        </MDBRow>
                                                    }
                                                    {formattedData.email &&
                                                        <MDBRow>
                                                            <MDBCol sm="4">
                                                                <MDBTypography className="mb-0 text-secondary">Email</MDBTypography>
                                                            </MDBCol>
                                                            <MDBCol sm="8" className="text-dark">
                                                                <span className='btn-link' style={{ textDecoration: `${formattedData?.email ? "underline" : "none"}` }} >
                                                                    {formattedData?.email || "--"}
                                                                </span>
                                                            </MDBCol>
                                                        </MDBRow>
                                                    }


                                                </div>
                                            </MDBCardBody>
                                        </MDBCard>
                                    </MDBCol>

                                    <MDBCol sm={12} md={6} className='mb-3'>
                                        {/* Minimal Membership Plan Card below Profile Image */}
                                        <MDBCard className="memberdetail-card  shadow h-100">
                                            <MDBCardBody>
                                                <MDBTypography tag="h5" className="mb-3 text-white"> Membership Details</MDBTypography>

                                                <div className="d-flex mb-2 justify-content-center">
                                                    <div>
                                                        <span className="text-secondary">Price</span>
                                                        <h5 className='text-white'> <i class="fas fa-rupee-sign"></i> {membership?.price ?
                                                            ` ${(membership.price).toLocaleString('en-IN')}`
                                                            : "--"}</h5>
                                                    </div>
                                                </div>
                                                <div className='d-flex justify-content-between mb-2'>
                                                    <div >
                                                        <span className="text-secondary">Expires</span>
                                                        <p className='m-0 text-white'>{memberData.expirydate ? formatDate(memberData.expirydate) : "--"}</p>
                                                    </div>
                                                    <div className="square border-end pe-3 me-3"></div>
                                                    {remainingSessions !== null && <>
                                                        <div className="">
                                                            <span className="text-secondary">Sessions</span>
                                                            <p className='m-0 text-white'>{remainingSessions}</p>
                                                        </div>

                                                        <div className="square border-end pe-3 me-3"></div></>}
                                                    <div className="">
                                                        <span className="text-secondary">Last check-in</span>
                                                        <p className='m-0 text-white'>{memberData?.attendance && memberData?.attendance.length > 0 ? formatDate(memberData?.attendance[0]?.intime) : "--"}</p>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-between align-items-center profile-name">
                                                    <MDBTypography tag="h5" className="mb-0 text-white">
                                                        {membership?.displayName
                                                            ? membership.displayName
                                                            : membership?.name
                                                                ? membership.name
                                                                : "No Plan Associated"}
                                                        <MDBIcon fas icon="check-circle text-success" />
                                                    </MDBTypography>

                                                    <MDBBadge color="success" pill className='p-2'>{!memberData.issuspend ? memberData.membershipstatus ? memberData.membershipstatus : ((new Date(memberData.expirydate) < new Date()) ? "Inactive" : "Active") : "suspend"}</MDBBadge>
                                                </div>
                                                <div className="upgrade-btn">
                                                    <MDBBtn rounded color="primary" size="sm" block onClick={() => navigate('/membershipplans')}>
                                                        <MDBIcon fas icon="shield-alt me-1" /> Upgrade Plan
                                                    </MDBBtn>
                                                </div>
                                            </MDBCardBody>
                                        </MDBCard>
                                    </MDBCol>



                                </MDBRow>
                            </MDBCol>
                            <MDBCol className='col-12'>
                                <MDBRow>
                                    <MDBCol sm={12} md={6} className='mb-3'>
                                        <MDBCard className=" shadow h-100">
                                            <MDBCardBody>
                                                <MDBTypography tag="h5" className="mb-3"> <i class="fas fa-id-badge me-2 colr-icon"></i>  Personal Details</MDBTypography>
                                                <MDBRow>
                                                    <MDBCol sm="6">
                                                        <MDBTypography className="mb-0 text-muted">Age</MDBTypography>
                                                    </MDBCol>
                                                    <MDBCol sm="6" className="text-dark">
                                                        {formattedData.age ? formattedData.age + " " + "years" : "--"}
                                                    </MDBCol>
                                                </MDBRow>
                                                <hr style={{ margin: '15px 0px' }} />
                                                <MDBRow>
                                                    <MDBCol sm="6">
                                                        <MDBTypography className="mb-0 text-muted">Gender</MDBTypography>
                                                    </MDBCol>
                                                    <MDBCol sm="6" className="text-dark">
                                                        {formattedData.gender ? formattedData.gender : "--"}
                                                    </MDBCol>
                                                </MDBRow>
                                                <hr style={{ margin: '15px 0px' }} />
                                                <MDBRow>
                                                    <MDBCol sm="6">
                                                        <MDBTypography className="mb-0 text-muted">Blood Group</MDBTypography>
                                                    </MDBCol>
                                                    <MDBCol sm="6" className="text-dark">
                                                        {formattedData.bloodGroup ? formattedData.bloodGroup : "--"}
                                                    </MDBCol>
                                                </MDBRow>
                                                <hr style={{ margin: '15px 0px' }} />
                                                <MDBRow>
                                                    <MDBCol sm="6">
                                                        <MDBTypography className="mb-0 text-muted">Height/Weight</MDBTypography>
                                                    </MDBCol>
                                                    <MDBCol sm="6" className="text-dark">
                                                        {formattedData.height} / {formattedData.weight}
                                                    </MDBCol>
                                                </MDBRow>
                                                <hr style={{ margin: '15px 0px' }} />
                                                <MDBRow>
                                                    <MDBCol sm="6">
                                                        <MDBTypography className="mb-0 text-muted">Address</MDBTypography>
                                                    </MDBCol>
                                                    <MDBCol sm="6" className=" text-dark">
                                                        {formattedData.address}
                                                    </MDBCol>
                                                </MDBRow>

                                            </MDBCardBody>
                                        </MDBCard>
                                    </MDBCol>
                                    <MDBCol sm={12} md={6} className='mb-3'>
                                        {/* Recent Activity */}
                                        <MDBCard className="shadow h-100">
                                            <MDBCardBody>
                                                <MDBTypography tag="h5" className="mb-3"> <MDBIcon fas icon="sign-out-alt me-2 colr-icon" /> Recent Check-ins</MDBTypography>

                                                {memberData?.attendance && memberData?.attendance?.length > 0 ? (
                                                    memberData?.attendance.slice(0, 2).map((session) => (
                                                        <div className="mb-3 py-2 border-bottom" key={session._id}>
                                                            <div className="d-flex justify-content-between align-items-start">
                                                                <div className='flex-grow-1'>
                                                                    <MDBTypography tag="h6" className="mb-1">
                                                                        {session.trainer ? (
                                                                            <div className="d-flex align-items-center gap-2">
                                                                                <div className='trainer-dp'>
                                                                                    <img src={coach} alt="" />
                                                                                </div>
                                                                                <div>
                                                                                    <span className='trai-labe'>Trainer</span>
                                                                                    <div>{session.trainer}</div>
                                                                                </div>
                                                                            </div>


                                                                        ) : (
                                                                            <div>Self Check-in</div>
                                                                        )}
                                                                    </MDBTypography>

                                                                    {/* <MDBTypography tag="h6" className="mb-1">
                                                                        {session.trainer ? `Trainer : ${session.trainer}` : "Self Check-in"}
                                                                    </MDBTypography> */}
                                                                    <div className="text-muted">
                                                                        <div>
                                                                            <label className='recent-label'>Check-in</label>  <span className='mx-2'>:</span> <span className='text-dark'> {formatDateTimeWithTZ(session.intime)}</span>
                                                                        </div>
                                                                        {session.outtime && (
                                                                            <div>
                                                                                <label className='recent-label'>Check-out</label>  <span className='mx-2'>:</span> <span className='text-dark'> {formatDateTimeWithTZ(session.outtime)}</span>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="text-end">
                                                                    {session.outtime ? (
                                                                        <span className="badge bg-success">
                                                                            {calculateDuration(session.intime, session.outtime)}
                                                                        </span>
                                                                    ) : (
                                                                        <span className="badge bg-warning text-dark">In Progress</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className="text-center py-3">
                                                        <p>No recent check-ins found</p>
                                                    </div>
                                                )}


                                                <div className="text-center mt-3">
                                                    <MDBBtn color="link" onClick={() => navigate(`/membercheckins`)}>
                                                        View All Check-ins
                                                    </MDBBtn>
                                                </div>


                                            </MDBCardBody>
                                        </MDBCard>
                                    </MDBCol>

                                </MDBRow>
                            </MDBCol>
                        </MDBRow>
                    </div>
                </div>
            </div >

            <MDBModal tabIndex='-1' open={editMember} onClose={() => setEditMember(false)}>
                <MDBModalDialog centered size='lg'>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Edit Profile</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={toggleEdit}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <div>
                                <CreateMember
                                    id={null}
                                    index={null}
                                    onsubmit={onsubmit}
                                    backallback={createMemberCallback}
                                    submit="0"
                                    mId={getMemberId()}
                                    addandSave={addandSave}
                                    from={"reload"}
                                    path={"member"}
                                    gymid={getGymId()}
                                />
                            </div>
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </>

    );
};

export default MemberProfile;